import { render, staticRenderFns } from "./ListAddForm.vue?vue&type=template&id=0042158c&scoped=true&"
import script from "./ListAddForm.vue?vue&type=script&lang=js&"
export * from "./ListAddForm.vue?vue&type=script&lang=js&"
import style0 from "./ListAddForm.vue?vue&type=style&index=0&id=0042158c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0042158c",
  null
  
)

export default component.exports